module.exports = __webpack_public_path__ + "img/111.48063bf3.png";